import errorIcon from "../../images/icons/toaster/error.svg";
import warningIcon from "../../images/icons/toaster/warning.svg";
import successIcon from "../../images/icons/toaster/success.svg";
import infoIcon from "../../images/icons/toaster/info.svg";
import defaultIcon from "../../images/icons/toaster/default.svg";
import { Toast } from "react-hot-toast";
import { COLORS } from "./colors";

export enum ToastTypeEnum {
  DEFAULT = "default",
  ERROR = "error",
  WARNING = "warning",
  SUCCESS = "success",
  INFO = "info",
}

export type ToastType = (typeof ToastTypeEnum)[keyof typeof ToastTypeEnum];

export interface CustomToastProps {
  t: Toast;
  type: ToastType;
  text: string;
}

const toastIcons = {
  [ToastTypeEnum.DEFAULT]: defaultIcon,
  [ToastTypeEnum.ERROR]: errorIcon,
  [ToastTypeEnum.WARNING]: warningIcon,
  [ToastTypeEnum.SUCCESS]: successIcon,
  [ToastTypeEnum.INFO]: infoIcon,
};

export const toastColors = {
  [ToastTypeEnum.DEFAULT]: COLORS.gray,
  [ToastTypeEnum.ERROR]: COLORS.warning,
  [ToastTypeEnum.WARNING]: COLORS.main2,
  [ToastTypeEnum.SUCCESS]: COLORS.main1,
  [ToastTypeEnum.INFO]: COLORS.blue,
};

export const toastTitles = {
  [ToastTypeEnum.DEFAULT]: "Інформаційне повідомлення",
  [ToastTypeEnum.ERROR]: "Помилка",
  [ToastTypeEnum.WARNING]: "Попередження",
  [ToastTypeEnum.SUCCESS]: "Повідомлення про успіх",
  [ToastTypeEnum.INFO]: "Інформаційне повідомлення",
};

export default toastIcons;
